(function() {
  // ====== SIZE CHART DATA ======
  // Source: bondandbinder.com product-page size charts (verified June 2026;
  // Long Magic Max corrected August 2026).
  //
  // Each size carries:
  //   chest / arm : measurement ranges in CM (the tool converts user input to cm).
  //   variant     : the Shopify variant ID for that size, in the default colour.
  //   display     : optional. What the USER sees as the size name. If absent,
  //                 the internal `size` is shown. Used so the Magic Max top sizes
  //                 read "XXL" / "3XL" (matching the size chart documents) while
  //                 the internal label stays consistent with Shopify's naming.
  //
  // Default colours (variant IDs are colour-specific):
  //   Long Magic Max  -> blue
  //   Short Magic Max -> orange (only colour)
  //   Corset Binder   -> black
  //   Active Comp Top -> black
  //
  // August 2026 corrections (Long Magic Max):
  //   XL2 chest corrected from 97-102 (duplicated XL value on the old chart)
  //   to 102-107, matching the corrected published chart.
  //   XL3 added to the logic: chest 107-112 (corroborated against gc2b),
  //   arm 66-74 EXTRAPOLATED from the size progression, pending measurement
  //   of a physical garment. If a real measurement contradicts 66-74, update
  //   the arm range here and in the published chart image.
  //
  // Sizes sold but NOT charted are intentionally omitted from the logic so the
  // tool never recommends a size we have no measurements for. Their variant IDs
  // are parked in `unlistedVariants` for future use once measurements arrive:
  //   Corset Binder   4XL -> 46774560620827
  //   Corset Binder   5XL -> 46774560686363
  //   Corset Binder   6XL -> 46774560751899
  // Anyone measuring past the top charted size hits the "email us" path.
  var SIZE_CHARTS = {
    longMagicMax: {
      name: "Long Magic Max Binder",
      url: "https://bondandbinder.com/products/long-magic-max-binder-blue",
      sizes: [
        { size: "XS",  chest: [76, 81],   arm: [30, 33], variant: "45435580678427" },
        { size: "S",   chest: [81, 87],   arm: [33, 40], variant: "45435580711195" },
        { size: "M",   chest: [87, 92],   arm: [36, 43], variant: "45435580743963" },
        { size: "L",   chest: [92, 97],   arm: [40, 50], variant: "45435580776731" },
        { size: "XL",  chest: [97, 102],  arm: [50, 58], variant: "45435580809499" },
        { size: "XL2", chest: [102, 107], arm: [58, 66], variant: "45435580842267", display: "XXL" },
        { size: "XL3", chest: [107, 112], arm: [66, 74], variant: "45435580875035", display: "3XL" }
      ]
    },
    shortMagicMax: {
      name: "Short Magic Max Binder",
      url: "https://bondandbinder.com/products/short-magic-max-binder-orange",
      sizes: [
        { size: "XS",  chest: [76, 81],   arm: [30, 33], variant: "45435608170779" },
        { size: "S",   chest: [81, 87],   arm: [33, 40], variant: "45435608203547" },
        { size: "M",   chest: [87, 92],   arm: [36, 43], variant: "45435608236315" },
        { size: "L",   chest: [92, 97],   arm: [40, 50], variant: "45435608269083" },
        { size: "XL",  chest: [97, 102],  arm: [50, 58], variant: "45435608301851" },
        { size: "XL2", chest: [102, 107], arm: [58, 66], variant: "45435608334619", display: "XXL" }
      ]
    },
    corsetBinder: {
      name: "Corset Binder",
      url: "https://bondandbinder.com/products/corset-binder-black",
      // Chest-only. The generic Bond and Binder chart this product uses publishes
      // arm ("shoulder width") bands with gaps between them (e.g. 47-50 cm is
      // uncovered), so sizing on arm here over-recommends. Chest is the primary
      // measurement and is reliable.
      sizes: [
        { size: "XS",  chest: [76, 81],   variant: "46774560162075" },
        { size: "S",   chest: [81, 87],   variant: "46774560227611" },
        { size: "M",   chest: [87, 92],   variant: "46774560293147" },
        { size: "L",   chest: [92, 97],   variant: "46774560358683" },
        { size: "XL",  chest: [97, 102],  variant: "46774560424219" },
        { size: "2XL", chest: [102, 107], variant: "46774560489755" },
        { size: "3XL", chest: [107, 112], variant: "46774560555291" }
      ]
      ,
      unlistedVariants: {
        "4XL": "46774560620827",
        "5XL": "46774560686363",
        "6XL": "46774560751899"
      }
    },
    activeCompression: {
      name: "Active Compression Top",
      url: "https://bondandbinder.com/products/active-compression-top-black",
      // Chest-only, same reasoning as the Corset (shared generic chart with
      // gapped arm bands). Active sells XS-XL2.
      sizes: [
        { size: "XS",  chest: [76, 81],   variant: "45435604369691" },
        { size: "S",   chest: [81, 87],   variant: "45435604402459" },
        { size: "M",   chest: [87, 92],   variant: "45435604435227" },
        { size: "L",   chest: [92, 97],   variant: "45435604467995" },
        { size: "XL",  chest: [97, 102],  variant: "45435604500763" },
        { size: "XL2", chest: [102, 107], variant: "45435604533531" }
      ]
    }
  };

  // ====== STATE ======
  var state = {
    unit: "in",
    chest: null,
    bicep: null,
    height: null,
    use: null,
    coverage: null,
    currentStep: 1
  };

  // ====== UNIT CONVERSION ======
  function toCm(value, unit) {
    if (unit === "in") return value * 2.54;
    return value;
  }

  // ====== URL BUILDER ======
  // Appends the size-specific variant so the user lands on the product page with
  // their size pre-selected. Falls back to the bare product URL if (and only if)
  // a size has no variant ID, which should not happen for any in-range size.
  function buildUrl(product, sizeObj) {
    if (sizeObj && sizeObj.variant) {
      return product.url + "?variant=" + sizeObj.variant;
    }
    return product.url;
  }

  // ====== DISPLAY LABEL ======
  // What the user sees for a size name. Defaults to the internal size unless a
  // `display` override is set (used to show "XXL" / "3XL" for the Magic Max top sizes).
  function displayLabel(sizeObj) {
    if (!sizeObj) return "";
    return sizeObj.display || sizeObj.size;
  }

  // ====== SIZING LOGIC ======
  // Brand rule: "if between sizes, choose the larger size."
  // Implementation: strict less-than comparison means boundary values round up.
  // Returns the matched size OBJECT (so callers can read variant + display)
  // alongside the flags.
  function findSize(product, chestCm, bicepCm) {
    var sizes = product.sizes;
    var chestMatches = sizes.filter(function(s) { return chestCm < s.chest[1]; });
    if (chestMatches.length === 0) {
      return { sizeObj: sizes[sizes.length - 1], outOfRange: true };
    }
    if (bicepCm && sizes[0].arm) {
      var armMatches = chestMatches.filter(function(s) { return bicepCm < s.arm[1]; });
      if (armMatches.length === 0) {
        var armFit = sizes.find(function(s) { return bicepCm < s.arm[1]; });
        if (armFit) return { sizeObj: armFit, sizedUpForArm: true };
        return { sizeObj: sizes[sizes.length - 1], outOfRange: true };
      }
      return { sizeObj: armMatches[0], outOfRange: false };
    }
    return { sizeObj: chestMatches[0], outOfRange: false };
  }

  // ====== RECOMMENDATION ======
  function recommend() {
    var chestCm = toCm(state.chest, state.unit);
    var bicepCm = toCm(state.bicep, state.unit);
    var heightCm = toCm(state.height, state.unit);

    var longResult = findSize(SIZE_CHARTS.longMagicMax, chestCm, bicepCm);
    var shortResult = findSize(SIZE_CHARTS.shortMagicMax, chestCm, bicepCm);
    var corsetResult = findSize(SIZE_CHARTS.corsetBinder, chestCm, bicepCm);
    var activeResult = findSize(SIZE_CHARTS.activeCompression, chestCm, bicepCm);

    var primary, primaryResult, reasoning;

    if (state.use === "active") {
      primary = SIZE_CHARTS.activeCompression;
      primaryResult = activeResult;
      reasoning = "The Active Compression Top is our most active-friendly binder. Safe for sport and swimming where firmer binders aren't. The compression is lighter, which makes it more comfortable when you're moving and breathing hard.";
    } else if (state.use === "first") {
      primary = SIZE_CHARTS.activeCompression;
      primaryResult = activeResult;
      reasoning = "For your first binder, we recommend starting with the Active Compression Top. The compression is lighter than our other binders, so it's easier to get used to and more comfortable while your body adjusts to binding.";
    } else if (state.use === "discreet") {
      primary = SIZE_CHARTS.corsetBinder;
      primaryResult = corsetResult;
      reasoning = "The Corset Binder has the most discreet silhouette in our range. Designed specifically for layering under tank tops, fitted t-shirts, and tight clothing. Same strong compression as our Magic Max binders.";
    } else {
      var preferLong = false;
      if (state.coverage === "more") preferLong = true;
      else if (state.coverage === "less") preferLong = false;
      else preferLong = heightCm >= 170;

      if (preferLong) {
        primary = SIZE_CHARTS.longMagicMax;
        primaryResult = longResult;
        reasoning = "The Long Magic Max is our highest-compression binder with extra torso coverage. About 8 inches longer than the Short version, running further down the torso. Three layers in the front, two in the back. Built for full-day everyday wear.";
      } else {
        primary = SIZE_CHARTS.shortMagicMax;
        primaryResult = shortResult;
        reasoning = "The Short Magic Max is our highest-compression binder in the shorter, crop-style cut. Easier under crop tops or shorter shirts. Three layers in the front, two in the back. Built for full-day everyday wear.";
      }
    }

    var allProducts = [
      { product: SIZE_CHARTS.longMagicMax, result: longResult, key: "long" },
      { product: SIZE_CHARTS.shortMagicMax, result: shortResult, key: "short" },
      { product: SIZE_CHARTS.corsetBinder, result: corsetResult, key: "corset" },
      { product: SIZE_CHARTS.activeCompression, result: activeResult, key: "active" }
    ];

    var alternates = allProducts.filter(function(p) {
      return p.product.name !== primary.name;
    }).map(function(p) {
      var reason = "";
      if (p.key === "long") reason = "Longer cut with extra torso coverage. Best if you want more coverage under shirts.";
      else if (p.key === "short") reason = "Shorter cut. Best for shorter frames or layering under crop tops.";
      else if (p.key === "corset") reason = "Most discreet silhouette. Best for layering under fitted clothing. Hand wash only.";
      else if (p.key === "active") reason = "Lighter compression. Safe for sport and swimming. Reversible. Available in black or coffee.";
      return {
        name: p.product.name,
        url: buildUrl(p.product, p.result.sizeObj),
        size: displayLabel(p.result.sizeObj),
        outOfRange: p.result.outOfRange,
        reason: reason
      };
    });

    return {
      primary: {
        name: primary.name,
        url: buildUrl(primary, primaryResult.sizeObj),
        size: displayLabel(primaryResult.sizeObj),
        reasoning: reasoning,
        outOfRange: primaryResult.outOfRange,
        sizedUpForArm: primaryResult.sizedUpForArm
      },
      alternates: alternates
    };
  }

  // ====== UI ======
  function $(sel) { return document.querySelector(sel); }
  function $$(sel) { return document.querySelectorAll(sel); }

  function setUnit(unit) {
    state.unit = unit;
    $("#bb-unit-cm").setAttribute("aria-pressed", unit === "cm" ? "true" : "false");
    $("#bb-unit-in").setAttribute("aria-pressed", unit === "in" ? "true" : "false");
    ["bb-chest-unit", "bb-bicep-unit", "bb-height-unit"].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.textContent = unit === "cm" ? "cm" : "in";
    });
    if (unit === "in") {
      $("#bb-chest").setAttribute("placeholder", "e.g. 37");
      $("#bb-bicep").setAttribute("placeholder", "e.g. 13");
      $("#bb-height").setAttribute("placeholder", "e.g. 69");
    } else {
      $("#bb-chest").setAttribute("placeholder", "e.g. 95");
      $("#bb-bicep").setAttribute("placeholder", "e.g. 32");
      $("#bb-height").setAttribute("placeholder", "e.g. 175");
    }
  }

  $("#bb-unit-cm").addEventListener("click", function() { setUnit("cm"); });
  $("#bb-unit-in").addEventListener("click", function() { setUnit("in"); });

  function goToStep(n) {
    $$(".bb-step").forEach(function(s) { s.classList.remove("bb-step--active"); });
    var target = document.querySelector('[data-step="' + n + '"]');
    if (target) target.classList.add("bb-step--active");
    state.currentStep = n;
    $$(".bb-progress__dot").forEach(function(dot, i) {
      dot.classList.remove("bb-progress__dot--active", "bb-progress__dot--done");
      if (i + 1 < n) dot.classList.add("bb-progress__dot--done");
      else if (i + 1 === n) dot.classList.add("bb-progress__dot--active");
    });
  }

  $$("[data-back]").forEach(function(btn) {
    btn.addEventListener("click", function() {
      var current = parseInt(btn.getAttribute("data-back"), 10);
      goToStep(current - 1);
    });
  });

  function showError(id, msg) { $("#" + id).textContent = msg; }
  function clearError(id) { $("#" + id).textContent = ""; }

  function validateMeasurement(value, unit, type) {
    var ranges = {
      chest: { cm: [50, 200], in: [20, 80] },
      bicep: { cm: [15, 80], in: [6, 32] },
      height: { cm: [120, 230], in: [48, 90] }
    };
    var range = ranges[type][unit];
    var min = range[0], max = range[1];
    if (!value || isNaN(value)) return "Please enter a number.";
    if (value < min || value > max) {
      return "Please enter a value between " + min + " and " + max + " " + (unit === "cm" ? "cm" : "in") + ".";
    }
    return null;
  }

  $("#bb-next-1").addEventListener("click", function() {
    var val = parseFloat($("#bb-chest").value);
    var err = validateMeasurement(val, state.unit, "chest");
    if (err) { showError("bb-chest-error", err); return; }
    clearError("bb-chest-error");
    state.chest = val;
    goToStep(2);
  });

  $("#bb-next-2").addEventListener("click", function() {
    var val = parseFloat($("#bb-bicep").value);
    var err = validateMeasurement(val, state.unit, "bicep");
    if (err) { showError("bb-bicep-error", err); return; }
    clearError("bb-bicep-error");
    state.bicep = val;
    goToStep(3);
  });

  $("#bb-next-3").addEventListener("click", function() {
    var val = parseFloat($("#bb-height").value);
    var err = validateMeasurement(val, state.unit, "height");
    if (err) { showError("bb-height-error", err); return; }
    clearError("bb-height-error");
    state.height = val;
    goToStep(4);
  });

  $("#bb-next-4").addEventListener("click", function() {
    var checked = document.querySelector('input[name="bb-use"]:checked');
    if (!checked) { showError("bb-use-error", "Please choose one."); return; }
    clearError("bb-use-error");
    state.use = checked.value;
    goToStep(5);
  });

  $("#bb-submit").addEventListener("click", function() {
    var checked = document.querySelector('input[name="bb-coverage"]:checked');
    if (!checked) { showError("bb-coverage-error", "Please choose one."); return; }
    clearError("bb-coverage-error");
    state.coverage = checked.value;

    var rec = recommend();

    $("#bb-product-name").textContent = rec.primary.name;
    $("#bb-size-badge").textContent = "Size " + rec.primary.size;
    $("#bb-size-badge").href = rec.primary.url;
    $("#bb-reasoning").textContent = rec.primary.reasoning;
    $("#bb-cta").href = rec.primary.url;
    $("#bb-cta").textContent = "Shop this binder";

    if (rec.primary.outOfRange) {
      $("#bb-reasoning").textContent = "Your measurements are at the upper end of our size range. We recommend reaching out before you order. Email admin@bondandbinder.com and we'll help you find the best fit.";
      $("#bb-size-badge").textContent = "Get in touch";
      $("#bb-cta").textContent = "Email Bond and Binder";
      $("#bb-cta").href = "mailto:admin@bondandbinder.com?subject=Sizing%20help";
      $("#bb-size-badge").href = "mailto:admin@bondandbinder.com?subject=Sizing%20help";
    }

    var altsHtml = rec.alternates.map(function(alt) {
      // An alternate that's out of range links to the bare product page rather
      // than a wrong-size variant, and shows no size badge.
      var sizeBadge = alt.outOfRange ? "" : '<span class="bb-alt__size">Size ' + alt.size + '</span>';
      return '<div class="bb-alt">' +
        '<div class="bb-alt__name">' +
        '<a href="' + alt.url + '" target="_blank" rel="noopener">' + alt.name + '</a>' +
        sizeBadge +
        '</div>' +
        '<p class="bb-alt__reason">' + alt.reason + '</p>' +
        '</div>';
    }).join("");
    $("#bb-alts").innerHTML = altsHtml;

    $$(".bb-step").forEach(function(s) { s.classList.remove("bb-step--active"); });
    $("#bb-result").classList.add("bb-result--active");
    $$(".bb-progress__dot").forEach(function(dot) {
      dot.classList.remove("bb-progress__dot--active");
      dot.classList.add("bb-progress__dot--done");
    });
  });

  $("#bb-alts-toggle").addEventListener("click", function() {
    var btn = $("#bb-alts-toggle");
    var content = $("#bb-alts");
    var isOpen = content.dataset.open === "true";
    content.dataset.open = isOpen ? "false" : "true";
    btn.setAttribute("aria-expanded", isOpen ? "false" : "true");
  });

  $("#bb-restart").addEventListener("click", function() {
    state.chest = null; state.bicep = null; state.height = null;
    state.use = null; state.coverage = null; state.currentStep = 1;
    $("#bb-chest").value = ""; $("#bb-bicep").value = ""; $("#bb-height").value = "";
    $$('input[name="bb-use"]').forEach(function(r) { r.checked = false; });
    $$('input[name="bb-coverage"]').forEach(function(r) { r.checked = false; });
    $$(".bb-error").forEach(function(e) { e.textContent = ""; });
    $("#bb-result").classList.remove("bb-result--active");
    $("#bb-alts").dataset.open = "false";
    $("#bb-alts-toggle").setAttribute("aria-expanded", "false");
    $$(".bb-progress__dot").forEach(function(dot, i) {
      dot.classList.remove("bb-progress__dot--done", "bb-progress__dot--active");
      if (i === 0) dot.classList.add("bb-progress__dot--active");
    });
    goToStep(1);
  });

  ["bb-chest", "bb-bicep", "bb-height"].forEach(function(id, idx) {
    $("#" + id).addEventListener("keydown", function(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        $("#bb-next-" + (idx + 1)).click();
      }
    });
  });

  // ====== SIZE CHART TABS ======
  $$(".bb-chart-tab").forEach(function(tab) {
    tab.addEventListener("click", function() {
      var target = tab.getAttribute("data-tab");
      $$(".bb-chart-tab").forEach(function(t) { t.setAttribute("aria-selected", "false"); });
      tab.setAttribute("aria-selected", "true");
      $$(".bb-chart-panel").forEach(function(p) { p.classList.remove("bb-chart-panel--active"); });
      var panel = document.querySelector('[data-panel="' + target + '"]');
      if (panel) panel.classList.add("bb-chart-panel--active");
    });
  });

  // ====== FAQ ACCORDION ======
  $$(".bb-faq__question").forEach(function(q) {
    q.addEventListener("click", function() {
      var item = q.closest(".bb-faq__item");
      var isOpen = item.dataset.open === "true";
      item.dataset.open = isOpen ? "false" : "true";
    });
  });
})();